<div class="row rounded-card" id="patterns-settings">
  <div class="flex flex-wrap justify-between items-end mb-4" id="setting-view-header-wr">
    <div class="flex flex-col">
      <h2 data-testid="specification-title">Specifications</h2>
      <span class="text-base">Create warranties specifications</span>
    </div>
    <div class="flex items-center gap-2">
      <button data-testid="add-specification-btn" class="btn primary-btn" (click)="displayCreateSpecModalbox()">Add specification</button>
    </div>
  </div>
  <hr class="mb-1 mt-2 border-t">
  <section>
    <div class="col-12 mt-4">
      <p-table [value]="paginatedSpecifications">
        <ng-template #header>
          <tr>
            <th>
              <div class="header-wr">
                <span data-testid="specification-name-header" class="col-name">Specification name</span>
              </div>
            </th>
            <th>
              <div class="header-wr">
                <span data-testid="specification-type-header" class="col-name">Specification Type</span>
              </div>
            </th>
            <th>
              <div class="header-wr">
                <span data-testid="specification-value-header" class="col-name">Specification value</span>
              </div>
            </th>
            <th>
              <div class="header-wr">
                <span data-testid="specification-role-header" class="col-name">Specification role</span>
              </div>
            </th>
            <th>
              <div class="header-wr">
                <span data-testid="specification-market-header" class="col-name">Specification market</span>
              </div>
            </th>
            <th>
              <div class="header-wr">
                <span data-testid="specification-retailer-header" class="col-name">Specification Retailer</span>
              </div>
            </th>
            <th>
              <div class="header-wr">
                <span data-testid="specification-retailer-type-header" class="col-name">Specification Retailer Type</span>
              </div>
            </th>
            <th>
              <div class="header-wr">
                <span data-testid="specification-actions-header" class="col-name">Actions</span>
              </div>
            </th>
          </tr>
        </ng-template>
        <ng-template #body let-specification let-rowIndex="rowIndex">
          <tr [attr.data-id]="specification.id">
            <td>
              <span class="p-column-title">Specification name:</span>
              <span [attr.data-testid]="'specification-name-' + rowIndex">{{ specification.name | defaultValue }}</span>
            </td>
            <td>
              <span class="p-column-title">Specification Type:</span>
              <span [attr.data-testid]="'specification-type-' + rowIndex">{{ specification.specificationType | defaultValue }}</span>
            </td>
            <td>
              <span class="p-column-title">Specification value:</span>
              <span [attr.data-testid]="'specification-restriction-' + rowIndex">{{ specification.restriction | defaultValue }}</span>
            </td>
            <td>
              <span class="p-column-title">Specification role:</span>
              <span [attr.data-testid]="'specification-role-' + rowIndex">{{ specification.role?.name | defaultValue }}</span>
            </td>
            <td>
              <span class="p-column-title">Specification market:</span>
              <span [attr.data-testid]="'specification-market-' + rowIndex">{{ specification.market?.code | defaultValue }}</span>
            </td>
             <td>
              <span class="p-column-title">Specification retailer:</span>
              <span [attr.data-testid]="'specification-retailer-' + rowIndex">{{ specification.retailer?.code | defaultValue }}</span>
            </td>
            <td>
              <span class="p-column-title">Specification retailer type:</span>
              <span [attr.data-testid]="'specification-retailer-type-' + rowIndex">{{ specification.retailerType?.code | defaultValue }}</span>
            </td>
            <td class="actions-col">
              <div class="actions gap-2">
                <p-toggleswitch class="centred" [(ngModel)]="specification.isActive" (onChange)="onStateChange($event, specification)"
                [attr.data-testid]="'switch-' + rowIndex" />
                <button type="button" pTooltip="View" tooltipPosition="top" class="btn-icon-only ui-btn-view btn-icon icon-edit" (click)="onViewSpecification($event, specification)" [attr.data-testid]="'edit-' + rowIndex">
                  <span class="btn-label">Edit</span>
                </button>
                <button type="button" pTooltip="Remove specification" tooltipPosition="top" class="btn-icon-only ui-btn-view btn-icon icon-remove" (click)="onRemoveSpecification($event, specification.id)" [attr.data-testid]="'remove-' + rowIndex">
                  <span class="btn-label">Remove specification</span>
                </button>
              </div>
            </td>
          </tr>
        </ng-template>
        <ng-template #emptymessage>
          <tr>
            <td colspan="7">No specifications set yet.</td>
          </tr>
        </ng-template>
      </p-table>

      <!-- Pagination -->
      <app-custom-paginator
        data-testid="paginator"
        [first]="paginatorFirst"
        [rows]="paginatorRows"
        [totalRecords]="totalRecords"
        [rowsPerPageOptions]="[10, 20, 50]"
        [showCurrentPageReport]="true"
        [currentPageReportTemplate]="'PAGINATOR.CURRENT_PAGE_REPORT' | translate"
        [disabled]="totalRecords === 0"
        [alwaysShow]="true"
        [showFirstLastIcon]="true"
        [showPageLinks]="true"
        [showPageSizeSelector]="true"
        (onPageChange)="onPageChange($event)">
      </app-custom-paginator>

    </div>
  </section>
</div>

<!-- Modalbox: Create specification -->
<p-dialog [(visible)]="showCreateSpecModal" [modal]="true" [blockScroll]="true" [draggable]="false" [resizable]="false" [style]="{ height: '40rem' }" [closable]="true" [dismissableMask]="true" [header]="'New specification'" [styleClass]="'overflow-y-visible'">
  <form class="mt-0" [formGroup]="specificationForm">
    <div class="row">
      <div class="field-wr flex flex-col col-12 col-md-6 mb-3">
        <label for="specName">Specification name<i class="icon-required-field"></i></label>
        <input id="specName" type="text" formControlName="name" autocomplete="off" />
      </div>
      <div class="field-wr flex flex-col col-12 col-md-6 mb-3 mt-1">
        <label class="block text-sm" for="">Specification Type<i class="icon-required-field"></i></label>
        <app-custom-dropdown
          data-testid="specification-type-create"
          [options]="specificationTypeOptions"
          [isMultiselect]="false"
          [showSelectionChips]="true"
          [showClear]="true"
          [searchMode]="'local'"
          [pageSize]="specificationTypeRowsPerPageOption"
          optionLabel="value"
          optionValue="value"
          formControlName="specificationType"
          [placeholder]="'Select a Specification Type'">
        </app-custom-dropdown>
      </div>
      <div class="field-wr flex flex-col col-12 col-md-6 mb-3">
        <label class="block text-sm" for="">Specification value<i class="icon-required-field"></i></label>
        <input type="text" formControlName="restriction" autocomplete="off" />
      </div>
      <div class="field-wr flex flex-col col-12 col-md-6 mb-3 mt-1">
        <label class="block text-sm" for="roles">Specification role</label>
        <app-custom-dropdown
          data-testid="roles-create"
          [isMultiselect]="false"
          [showSelectionChips]="true"
          [showClear]="true"
          [searchMode]="'remote'"
          [pageSize]="rolesRowsPerPageOption"
          [totalCount]="rolesTotalRecords"
          [totalPages]="getTotalPages(rolesTotalRecords, rolesRowsPerPageOption)"
          [options]="rolesList"
          optionLabel="text"
          optionValue="id"
          formControlName="role"
          [placeholder]="'Select role'"
          (onLazyLoad)="onLazyLoadRoles($event)">
        </app-custom-dropdown>
      </div>
      <div class="field-wr flex flex-col col-12 col-md-6 mb-3 mt-1">
        <label class="block text-sm" for="markets">Specification market</label>
        <app-custom-dropdown
          data-testid="markets-create"
          [isMultiselect]="false"
          [showSelectionChips]="true"
          [showClear]="true"
          [searchMode]="'remote'"
          [pageSize]="marketsRowsPerPageOption"
          [totalCount]="marketsTotalRecords"
          [totalPages]="getTotalPages(marketsTotalRecords, marketsRowsPerPageOption)"
          [options]="marketsList"
          optionLabel="text"
          optionValue="id"
          formControlName="market"
          [placeholder]="'Select market'"
          (onLazyLoad)="onLazyLoadMarkets($event)">
        </app-custom-dropdown>
      </div>
      <div class="field-wr flex flex-col col-12 col-md-6 mb-3 mt-1">
        <label class="block text-sm" for="retailers">Specification retailer</label>
        <app-custom-dropdown
          data-testid="retailer-type-create"
          [isMultiselect]="false"
          [showSelectionChips]="true"
          [showClear]="true"
          [searchMode]="'remote'"
          [pageSize]="retailersRowsPerPageOption"
          [totalCount]="retailersTotalRecords"
          [totalPages]="getTotalPages(retailersTotalRecords, retailersRowsPerPageOption)"
          [options]="retailersList"
          optionLabel="text"
          optionValue="id"
          formControlName="retailer"
          [placeholder]="'Select retailer'"
          (onLazyLoad)="onLazyLoadRetailers($event)">
        </app-custom-dropdown>
      </div>
      <div class="field-wr flex flex-col col-12 col-md-6 mb-3 mt-1">
        <label class="block text-sm" for="retailerTypes">Specification retailer Type</label>
        <app-custom-dropdown
          data-testid="retailer-type-create"
          [isMultiselect]="false"
          [showSelectionChips]="true"
          [showClear]="true"
          [searchMode]="'remote'"
          [pageSize]="retailerTypesRowsPerPageOption"
          [totalCount]="retailerTypesTotalRecords"
          [totalPages]="getTotalPages(retailerTypesTotalRecords, retailerTypesRowsPerPageOption)"
          [options]="retailerTypesList"
          optionLabel="text"
          optionValue="id"
          formControlName="retailerType"
          [placeholder]="'Select retailer type'"
          (onLazyLoad)="onLazyLoadRetailerTypes($event)">
        </app-custom-dropdown>
      </div>
    </div>
  </form>

  <ng-template #footer>
    <button type="button" class="btn outline-btn" (click)="cancelCreateSpec()">Cancel</button>
    <button type="button" class="btn primary-btn" [disabled]="specificationForm.invalid"
      (click)="createSpecification()">Create specification</button>
  </ng-template>
</p-dialog>

<!-- Modalbox: Update specification -->
<p-dialog [(visible)]="showViewSpecModal" [modal]="true" [blockScroll]="true" [draggable]="false" [resizable]="false" [closable]="false" [style]="{ height: '40rem' }" [dismissableMask]="true" [header]="'Update specification'">
  <form class="mt-0" [formGroup]="updateSpecificationForm">
    <div class="row">
      <div class="field-wr flex flex-col col-12 col-md-6 mb-3">
        <label for="specName">Specification name<i class="icon-required-field"></i></label>
        <input id="specName" type="text" formControlName="name" autocomplete="off" />
      </div>
      <div class="field-wr flex flex-col col-12 col-md-6 mb-3 mt-1">
        <label class="block text-sm" for="">Specification Type<i class="icon-required-field"></i></label>
        <app-custom-dropdown
          data-testid="specification-type-update"
          [options]="specificationTypeOptions"
          [isMultiselect]="false"
          [showSelectionChips]="true"
          [showClear]="true"
          [searchMode]="'local'"
          [pageSize]="specificationTypeRowsPerPageOption"
          optionLabel="value"
          optionValue="value"
          formControlName="specificationType"
          [placeholder]="'Select a Specification Type'">
        </app-custom-dropdown>
      </div>
      <div class="field-wr flex flex-col col-12 col-md-6 mb-3">
        <label class="block text-sm" for="">Specification value<i class="icon-required-field"></i></label>
        <input type="text" formControlName="restriction" autocomplete="off" />
      </div>
      <div class="field-wr flex flex-col col-12 col-md-6 mb-3 mt-1">
        <label class="block text-sm" for="roles">Specification role</label>
        <app-custom-dropdown
          data-testid="roles-update"
          [isMultiselect]="false"
          [showSelectionChips]="true"
          [showClear]="true"
          [searchMode]="'remote'"
          [pageSize]="rolesRowsPerPageOption"
          [totalCount]="rolesTotalRecords"
          [totalPages]="getTotalPages(rolesTotalRecords, rolesRowsPerPageOption)"
          [options]="rolesList"
          optionLabel="text"
          optionValue="id"
          formControlName="role"
          [placeholder]="'Select role'"
          (onLazyLoad)="onLazyLoadRoles($event)">
        </app-custom-dropdown>
      </div>
      <div class="field-wr flex flex-col col-12 col-md-6 mb-3 mt-1">
        <label class="block text-sm" for="markets">Specification market</label>
        <app-custom-dropdown
          data-testid="markets-update"
          [isMultiselect]="false"
          [showSelectionChips]="true"
          [showClear]="true"
          [searchMode]="'remote'"
          [pageSize]="marketsRowsPerPageOption"
          [totalCount]="marketsTotalRecords"
          [totalPages]="getTotalPages(marketsTotalRecords, marketsRowsPerPageOption)"
          [options]="marketsList"
          optionLabel="text"
          optionValue="id"
          formControlName="market"
          [placeholder]="'Select market'"
          (onLazyLoad)="onLazyLoadMarkets($event)">
        </app-custom-dropdown>
      </div>
      <div class="field-wr flex flex-col col-12 col-md-6 mb-3 mt-1">
        <label class="block text-sm" for="retailerTypes">Specification retailer</label>
        <app-custom-dropdown
          data-testid="retailer-update"
          [isMultiselect]="false"
          [showSelectionChips]="true"
          [showClear]="true"
          [searchMode]="'remote'"
          [pageSize]="retailersRowsPerPageOption"
          [totalCount]="retailersTotalRecords"
          [totalPages]="getTotalPages(retailersTotalRecords, retailersRowsPerPageOption)"
          [options]="retailersList"
          optionLabel="text"
          optionValue="id"
          formControlName="retailer"
          [placeholder]="'Select retailer'"
          (onLazyLoad)="onLazyLoadRetailers($event)">
      </app-custom-dropdown>
      </div>
      <div class="field-wr flex flex-col col-12 col-md-6 mb-3 mt-1">
        <label class="block text-sm" for="retailerTypes">Specification retailer type</label>
        <app-custom-dropdown
          data-testid="retailer-types-update"
          [isMultiselect]="false"
          [showSelectionChips]="true"
          [showClear]="true"
          [searchMode]="'remote'"
          [pageSize]="retailerTypesRowsPerPageOption"
          [totalCount]="retailerTypesTotalRecords"
          [totalPages]="getTotalPages(retailerTypesTotalRecords, retailerTypesRowsPerPageOption)"
          [options]="retailerTypesList"
          optionLabel="text"
          optionValue="id"
          formControlName="retailerType"
          [placeholder]="'Select retailer type'"
          (onLazyLoad)="onLazyLoadRetailerTypes($event)">
        </app-custom-dropdown>
      </div>
    </div>
  </form>

  <ng-template #footer>
    <button type="button" class="btn outline-btn" (click)="cancelViewSpecification()">Cancel</button>
    <button type="button" class="btn primary-btn" [disabled]="updateSpecificationForm.invalid"
      (click)="saveSpecification()">Update specification</button>
  </ng-template>
</p-dialog>
